import { render, staticRenderFns } from "./EditorForm.vue?vue&type=template&id=012f5fd8&"
import script from "./EditorForm.vue?vue&type=script&lang=js&"
export * from "./EditorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports